module.exports = __webpack_public_path__ + "img/id-card-back.43842035.png";